(function() {
    'use strict';
    angular.module('wamasysApp').controller('ReportingZoneAnalysisController', controller);
    controller.$inject = ['ReportingZoneAnalysis', 'Principal', '$scope', '$interval', '$translate', '$uibModal'];
    function controller(api, Principal, $scope, $interval, $translate, $uibModal) {
        var vm = this;
        var timer;
        var evidenceCache = Object.create(null);
        var reportingCache = Object.create(null);
        var analysisRequest = 0;
        vm.form = {objectives: '', context: '', weeklyEnabled: true, previousPromptId: null};
        vm.prompts = []; vm.analyses = []; vm.promptPage = 0; vm.analysisPage = 0;
        vm.sections = ['kpiFacts', 'monitoringFacts', 'investigations', 'usageIdeas'];
        vm.load = load; vm.save = save; vm.run = run; vm.select = select;
        vm.promptHistory = promptHistory; vm.analysisHistory = analysisHistory;
        vm.hasUnsavedChanges = hasUnsavedChanges; vm.showSource = showSource;
        vm.sourceState = sourceState; vm.busy = busy; vm.evidenceParts = evidenceParts; vm.hasSource = hasSource; vm.reportingLinks = reportingLinks; vm.durationLabel = durationLabel;
        Principal.identity().then(function(account) {
            var roles = account && account.authorities || [];
            // La modification des prompts et le lancement manuel sont réservés aux administrateurs.
            vm.canEdit = roles.indexOf('ROLE_ADMIN') >= 0 || roles.indexOf('ROLE_SUPER_ADMIN') >= 0;
            vm.canRun = vm.canEdit;
        });
        load();
        $scope.$on('$destroy', function() { if (timer) { $interval.cancel(timer); } });

        function error(response) {
            vm.error = response && response.data && response.data.message || $translate.instant('wamasysApp.zoneAnalysis.requestFailed');
            if (response && response.status === 409) { vm.error = $translate.instant('wamasysApp.zoneAnalysis.conflict'); }
        }
        function applyPrompt(prompt) {
            vm.latestPrompt = prompt || null;
            vm.form = {
                objectives: prompt ? prompt.objectives : '', context: prompt ? prompt.context : '',
                weeklyEnabled: prompt ? prompt.weeklyEnabled : true, previousPromptId: prompt ? prompt.id : null
            };
        }
        function load() {
            vm.loading = true; vm.error = null;
            api.overview().$promise.then(function(data) {
                vm.areaName = data.areaName; vm.configured = data.configured;
                vm.prompts = data.prompts; vm.analyses = data.analyses;
                vm.promptPage = 0; vm.analysisPage = 0;
                applyPrompt(vm.prompts[0]);
                if (vm.analyses.length) { select(vm.analyses[0]); }
                polling();
            }, error).finally(function() { vm.loading = false; });
        }
        function save() {
            vm.saving = true; vm.error = null; vm.saved = false;
            api.savePrompt(angular.copy(vm.form)).$promise.then(function(prompt) {
                applyPrompt(prompt); vm.saved = true; promptHistory(0);
            }, error).finally(function() { vm.saving = false; });
        }
        function hasUnsavedChanges() {
            return vm.form.objectives !== (vm.latestPrompt ? vm.latestPrompt.objectives : '') ||
                vm.form.context !== (vm.latestPrompt ? vm.latestPrompt.context : '') ||
                vm.form.weeklyEnabled !== (vm.latestPrompt ? vm.latestPrompt.weeklyEnabled : true);
        }
        function busy() {
            return vm.analyses.some(function(item) {
                return (item.status === 'QUEUED' || item.status === 'RUNNING') &&
                    new Date(item.createdAt).getTime() > Date.now() - 2 * 60 * 60 * 1000;
            });
        }
        function run() {
            if (hasUnsavedChanges() || busy()) { return; }
            vm.launching = true; vm.error = null;
            api.run({}).$promise.then(function(result) {
                analysisHistory(0); select({id: result.id});
            }, error).finally(function() { vm.launching = false; });
        }
        function promptHistory(page) {
            vm.loadingPrompts = true;
            api.prompts({page: page}).$promise.then(function(items) {
                vm.prompts = items; vm.promptPage = page;
            }, error).finally(function() { vm.loadingPrompts = false; });
        }
        function analysisHistory(page) {
            var request = ++analysisRequest;
            vm.loadingAnalyses = true;
            return api.history({page: page}).$promise.then(function(items) {
                if (request !== analysisRequest) { return; }
                vm.analyses = items; vm.analysisPage = page; polling();
            }, error).finally(function() { if (request === analysisRequest) { vm.loadingAnalyses = false; } });
        }
        function select(item) {
            vm.selectedId = item.id; vm.loadingDetail = true; vm.source = null;
            api.detail({id: item.id}).$promise.then(function(detail) {
                // Une réponse ancienne ne doit pas remplacer une sélection plus récente.
                if (vm.selectedId !== detail.id) { return; }
                vm.detail = detail; vm.result = detail.resultJson ? angular.fromJson(detail.resultJson) : null;
                vm.snapshot = detail.snapshotJson ? angular.fromJson(detail.snapshotJson) : null;
                polling();
            }, error).finally(function() { if (vm.selectedId === item.id) { vm.loadingDetail = false; } });
        }
        function polling() {
            var pending = busy() || (vm.detail && (vm.detail.status === 'QUEUED' || vm.detail.status === 'RUNNING') &&
                new Date(vm.detail.createdAt).getTime() > Date.now() - 2 * 60 * 60 * 1000);
            if (!pending && timer) { $interval.cancel(timer); timer = null; }
            if (pending && !timer) {
                timer = $interval(function() {
                    // Actualiser uniquement les résultats : préserver les prompts en cours de saisie.
                    if (vm.analysisPage === 0) { analysisHistory(0); }
                    if (vm.detail && vm.detail.id === vm.selectedId && !vm.loadingDetail &&
                        (vm.detail.status === 'QUEUED' || vm.detail.status === 'RUNNING')) { select(vm.detail); }
                }, 10000);
            }
        }
        function hasSource(id) {
            return !!(vm.snapshot && vm.snapshot.sources && Object.prototype.hasOwnProperty.call(vm.snapshot.sources, id));
        }
        function showSource(id) {
            if (!hasSource(id)) { return; }
            // Afficher immédiatement la source, plutôt qu'un panneau éloigné en bas de page.
            var source = {id: id, data: angular.copy(vm.snapshot.sources[id]), state: sourceState(id)};
            $uibModal.open({
                templateUrl: 'zone-analysis-source.html', controllerAs: 'sourceVm',
                controller: ['$uibModalInstance', function(instance) {
                    this.source = source; this.close = function() { instance.close(); };
                }]
            });
        }
        function evidenceParts(value) {
            var text = value || '';
            if (evidenceCache[text]) { return evidenceCache[text]; }
            var parts = [], cursor = 0, match;
            // Découper le texte en segments, sans injecter de HTML fourni par l'IA.
            var numbers = /[+-]?\d+(?:[ \u00a0\u202f]\d{3})*(?:[.,]\d+)?(?:[ \u00a0\u202f]?(?:%|€|\$))?/g;
            while ((match = numbers.exec(text))) {
                if (match.index > cursor) { parts.push({text: text.slice(cursor, match.index), highlighted: false}); }
                parts.push({text: match[0], highlighted: true}); cursor = numbers.lastIndex;
            }
            if (cursor < text.length) { parts.push({text: text.slice(cursor), highlighted: false}); }
            evidenceCache[text] = parts;
            return parts;
        }
        function durationLabel(value) {
            if (value == null) { return '—'; }
            var seconds = Math.round(value / 1000);
            return seconds < 60 ? seconds + ' s' : Math.floor(seconds / 60) + ' min ' + (seconds % 60) + ' s';
        }
        function reportingLinks(sources) {
            var key = (sources || []).join('|');
            if (reportingCache[key]) { return reportingCache[key]; }
            var links = [], seen = {};
            (sources || []).forEach(function(id) {
                var state = sourceState(id);
                if (state && !seen[state]) { seen[state] = true; links.push({state: state}); }
            });
            reportingCache[key] = links;
            return links;
        }
        function sourceState(id) {
            if (id.indexOf('FINANCE_') === 0) { return 'reporting-agence'; }
            if (id.indexOf('MONITORING_') === 0) { return 'monitoring-rule-history'; }
            if (id === 'ACTIVITY_SIX_MONTHS') { return 'reporting-area-activity'; }
            return null;
        }
    }
})();
